import {apiInstance} from '../api';

const route = '/slider';

export class AdvertisingService {
  static async fetch() {
    return apiInstance.get(route);
  }

  static async create(advertise) {
    return apiInstance.post(route, advertise);
  }

  static async delete(advertiseId) {
    return apiInstance.delete(`${route}/${advertiseId}`);
  }

  static async update(advertiseId, updatedAdvertise) {
    return apiInstance.put(`${route}/${advertiseId}`, updatedAdvertise);
  }

}
